import React, { useEffect } from 'react';
import './styles.scss';
import Sidebar from 'components/sidebar';
import Header from 'components/header';
import { apiService } from 'services/base.service';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import { Outlet, useLocation } from 'react-router-dom';
import PageText from 'components/base/page-text';
import { ENUM_CATEGORY } from 'utils/enum';

import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

const CATEGORY_LIST: ENUM_CATEGORY[] = [ENUM_CATEGORY.FOOD, ENUM_CATEGORY.SHOP];

const DashboardContent = () => {
  const {
    category,
    activeCokitchen,
    setCokitchens,
    setCokitchenLoading,
    rightSection,
    isRightSectionWide,
    loggedInRole
  } = useDashboardContext();
  const { pathname } = useLocation();

  if (!CATEGORY_LIST.includes(category as ENUM_CATEGORY)) {
    localStorage.setItem(STORAGE_KEYS.CATEGORY, ENUM_CATEGORY.FOOD);
    location.reload();
  }

  const fetchCokitchens = async () => {
    try {
      setCokitchenLoading(true);
      const res = await apiService.get('cokitchens', {
        isInternal: true
      });
      const data = res.data.data;
      localStorage.setItem(STORAGE_KEYS.COKITCHEN_LIST, JSON.stringify(data));
      setCokitchens(data);
    } catch (err) {
      setCokitchens([]);
    } finally {
      setCokitchenLoading(false);
    }
  };

  useEffect(() => {
    fetchCokitchens();
  }, []);

  const hideSidebar = () => {
    return pathname.includes(ROUTE_KEYS.PRICING);
  };

  const permittedAccessWithoutCokitchen =
    loggedInRole === ENUM_ROLE.HR_ADMIN || loggedInRole === ENUM_ROLE.MARKETING_OPS_MANAGER;
  return (
    <div
      className={`min-h-screen flex  overflow-x-hidden ${!hideSidebar() ? 'lg:pl-[260px]' : ''}`}>
      {!hideSidebar() && (
        <div className='max-lg:hidden'>
          <Sidebar />
        </div>
      )}
      <div className='w-full flex flex-col h-screen'>
        <Header />

        {permittedAccessWithoutCokitchen || activeCokitchen?.id ? (
          <div className={`flex max-lg:flex-col ${rightSection ? 'lg:overflow-hidden' : ''}`}>
            <div className={`w-full p-6 lg:pr-14 pb-10 ${rightSection ? 'overflow-y-auto' : ''}`}>
              <Outlet />
            </div>

            {rightSection && (
              <div className={`right-section ${isRightSectionWide ? 'is-wide' : ''}`}>
                {rightSection}
              </div>
            )}
          </div>
        ) : (
          <PageText text='Loading co-kitchen data...' />
        )}
      </div>
    </div>
  );
};

export default DashboardContent;
